import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { DP_LIST, DP_UPDATE, DP_FILTER_SUPPLIERS, DP_FILTER_ACQUISITION_DETAILS, DP_FILTER_DESTINATIONS, DP_FILTER_DISBURSEMENTS, DELIVERY_PLAN_TASK_UPDATE } from '../../actions';
import { DeliveryPlanListSuccess, DeliveryPlanListError, DeliveryPlanUpdateSuccess, DeliveryPlanUpdateError, DeliveryPlanFilterSuppliersSuccess, DeliveryPlanFilterAcquisitionDetailsSuccess, DeliveryPlanFilterDestinationsSuccess, DeliveryPlanFilterDisbursementsSuccess, DeliveryPlanTaskUpdateSuccess, DeliveryPlanTaskUpdateError } from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onListSuppliersAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/suppliers', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onListAcquisitionDetailsAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/acquisition_details', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onListDestinationsAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/destinations', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onListDisbursementsAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/disbursements', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(DeliveryPlanListSuccess(response.data)); }
  catch (error) { yield put(DeliveryPlanListError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Éxito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(DeliveryPlanUpdateSuccess(response.data));
  } catch (error) { yield put(DeliveryPlanUpdateError(error)); }
}

function* onFilterSuppliers() {
  try { const response = yield call(onListSuppliersAsync); yield put(DeliveryPlanFilterSuppliersSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterAcquisitionDetails() {
  try { const response = yield call(onListAcquisitionDetailsAsync); yield put(DeliveryPlanFilterAcquisitionDetailsSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterDestinations() {
  try { const response = yield call(onListDestinationsAsync); yield put(DeliveryPlanFilterDestinationsSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterDisbursements() {
  try { const response = yield call(onListDisbursementsAsync); yield put(DeliveryPlanFilterDisbursementsSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(DP_LIST, onList); }
export function* watchUpdate() { yield takeEvery(DP_UPDATE, onUpdate); }
export function* watchFilterSuppliers() { yield takeEvery(DP_FILTER_SUPPLIERS, onFilterSuppliers); }
export function* watchFilterAcquisitionDetails() { yield takeEvery(DP_FILTER_ACQUISITION_DETAILS, onFilterAcquisitionDetails); }
export function* watchFilterDestinations() { yield takeEvery(DP_FILTER_DESTINATIONS, onFilterDestinations); }
export function* watchFilterDisbursements() { yield takeEvery(DP_FILTER_DISBURSEMENTS, onFilterDisbursements); }

const onDeliveryPlanTaskUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/delivery_plan_task/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onDeliveryPlanTaskUpdate(data) {
  try {
    const response = yield call(onDeliveryPlanTaskUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Éxito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(DeliveryPlanTaskUpdateSuccess(response.data));
  } catch (error) { yield put(DeliveryPlanTaskUpdateError(error)); }
}

export function* watchDeliveryPlanTaskUpdate() { yield takeEvery(DELIVERY_PLAN_TASK_UPDATE, onDeliveryPlanTaskUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchUpdate), fork(watchFilterSuppliers), fork(watchFilterAcquisitionDetails), fork(watchFilterDestinations), fork(watchFilterDisbursements), fork(watchDeliveryPlanTaskUpdate)]);
}
